import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { Box, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";
import { useTranslation } from "react-i18next";

type Props = {
  approval: "approved" | "rejected";
  date?: string;
  expert?: string;
};

const Approval = ({ approval, date, expert }: Props) => {
  const { t } = useTranslation();

  // Currently there is no expert info if the certificate comes through migration
  if (!date) return null;

  const approvalState = {
    approved: (
      <>
        <CheckIcon sx={{ color: "#00A600" }} />
        {expert ? (
          <Typography>
            {t(`workPermits:approvedBy`, {
              date: format(parseISO(date), "dd.MM.yyyy"),
              expert: expert,
            })}
          </Typography>
        ) : (
          <Typography>
            {t(`workPermits:approvedAt`, {
              date: format(parseISO(date), "dd.MM.yyyy"),
            })}
          </Typography>
        )}
      </>
    ),
    rejected: (
      <>
        <ClearIcon sx={{ color: "error.main" }} />
        {expert ? (
          <Typography>
            {t(`workPermits:rejectedBy`, {
              date: format(parseISO(date), "dd.MM.yyyy"),
              expert: expert,
            })}
          </Typography>
        ) : (
          <Typography>
            {t(`workPermits:rejectedAt`, {
              date: format(parseISO(date), "dd.MM.yyyy"),
            })}
          </Typography>
        )}
      </>
    ),
  };
  return (
    <Box display="flex" gap="0.5rem" paddingRight="44px">
      {approvalState[approval]}
    </Box>
  );
};

export default Approval;
